import type { StrictOmit } from '@frontend/duck-tape';
import { Icon, Text, XStack } from '@frontend/web-react';
import { mergeAndConcatClasses, safeCss } from '@frontend/web-utils';
import type { CheckboxProps as MCheckboxProps } from '@mantine/core';
import { Checkbox as MCheckbox } from '@mantine/core';

export type CheckboxProps = StrictOmit<MCheckboxProps, 'classNames' | 'color' | 'onChange' | 'variant'> & {
  onChange: (checked: boolean) => void;
};

const classNames: MCheckboxProps['classNames'] = {
  body: safeCss('text-p-sm text-textPrimary'),
  input: safeCss('border-2 border-neutral-900 rounded-sm'),
  root: safeCss('flex-1'),
};

// For now only supports one size, can add more variants if needed
/**
 * Should only be used if rendering a "one off" checkbox for presentational purposes
 */
export const Checkbox = ({ checked, className, label, onChange, ...props }: CheckboxProps) => {
  return (
    <XStack
      className={mergeAndConcatClasses('cursor-pointer justify-center hover-opacity-effect', className)}
      onClick={(e) => {
        e.stopPropagation();
        onChange(!checked);
      }}
      py="md"
    >
      <MCheckbox
        checked={checked}
        classNames={classNames}
        color={'neutral.9'}
        // TODO (ethan): Currently we don't handle indeterminate steps
        icon={({ className }) => <Icon className={className} color="inverse" name="IconCheck" size="xs" stroke={4} />}
        label={
          label ? (
            <Text color="primary" isSelectable={false} onClick={(e) => e.stopPropagation()} type="p-sm">
              {label}
            </Text>
          ) : null
        }
        onChange={(e) => onChange(e.target.checked)}
        onClick={(e) => e.stopPropagation()}
        {...props}
      />
    </XStack>
  );
};
